import { render, staticRenderFns } from "./RaterRateeSkillPage.vue?vue&type=template&id=1fd71b8f&"
import script from "./RaterRateeSkillPage.vue?vue&type=script&lang=ts&"
export * from "./RaterRateeSkillPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports